// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"575c20b160bd91090044","256":"ef3677ccff23c9758294","532":"91a8cc66ef7f6ef2542c"}[chunkId] + ".js";
};